import React, { useState, useContext, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation
} from "react-router-dom";

import NavBarTop from "./components/NavbarTop";
import NavBar from "./components/Sidebar";
import Teste from "./pages/Teste";
import Home from "./pages/Home";
import Produtos from "./pages/Produtos";
import ProdutosBloqueados from "./pages/ProdutosBloqueados";
import Perguntas from "./pages/Perguntas";
import Vendas from "./pages/VendasV2";
import VendasCardPreview from "./pages/VendasCardPreview";
import Logs from "./pages/Logs";
import Concorrencia from "./pages/Concorrencia";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Guias from "./pages/Guias";
import GestaoEstoque from "./pages/GestaoEstoque";
import VendasVendedor from "./pages/VendasVendedor";
import VendaManual from "./pages/VendaManual";
import NotFoundPage from "./pages/NotFoundPage";
import AnunciosDenuncias from "./pages/AnunciosDenuncias";
import Devolucoes from "./pages/Devolucoes";
import DevolucaoFornecedor from "./pages/DevolucaoFornecedor";
import NfeDevolucaoCliente from "./pages/NfeDevolucaoCliente";
import Reclamacoes from "./pages/Reclamacoes";
import CotacaoAutomatica from "./pages/CotacaoAutomatica";
import ListarCotacoes from "./pages/ListarCotacoes";
import CoberturaFuros from "./pages/CoberturaFuros";
import DivergenciasPreco from "./pages/DivergenciasPreco";
import PublicidadeML from "./pages/PublicidadeML";
import SaudeAnunciosML from "./pages/SaudeAnunciosML";
import MetricasAnuncios from "./pages/MetricasAnuncios";
import ResponderCotacao from "./pages/ResponderCotacao";
import DetalheCotacao from "./pages/DetalheCotacao";
import Servidor from "./pages/Servidor";
import AcompanhamentoPedidos from "./pages/AcompanhamentoPedidos";
import Despacho from "./pages/Despacho";
import PendenciasVendas from "./pages/PendenciasVendas";
import ProcessadorMonitoramento from "./pages/ProcessadorMonitoramento";
import ProcessadorMonitoramentoDia from "./pages/ProcessadorMonitoramentoDia";
import Tickets from "./pages/Tickets";
import TicketDetailPage from "./pages/TicketDetailPage";
import TicketCreatePage from "./pages/TicketCreatePage";
import TicketEditPage from './pages/TicketEditPage';
import Prospeccao from "./pages/Prospeccao";
import ProspeccaoDetalhes from "./pages/ProspeccaoDetalhes";
import Configuracoes from "./pages/Configuracoes";
import Dimensoes from "./pages/Dimensoes";
import LogsProdutos from "./pages/LogsProdutos";
import ExportarProdutos from "./pages/ExportarProdutos";
import ExportarClientes from "./pages/ExportarClientes";
import ExportarVendas from "./pages/ExportarVendas";
import ExportarConversas from "./pages/ExportarConversas";
import ExportarListasCompras from "./pages/ExportarListasCompras";
import ExportarMovimentacaoEstoque from "./pages/ExportarMovimentacaoEstoque";
import ListaComprasFornecedor from "./pages/ListaComprasFornecedor";
import ListasComprasDashboard from "./pages/ListasComprasDashboard";
import ListasCompras from "./pages/ListasCompras";
import ListasComprasKanban from "./pages/ListasComprasKanban";
import ListaCompraDetalhes from "./pages/ListaCompraDetalhes";
import NovaListaCompra from "./pages/NovaListaCompra";
import SupportWiki from "./pages/WikiPage";
import NotasFiscais from "./pages/NotasFiscais";
import Wiki from "./pages/WikiPage";
import ListaPromocoes from "./pages/ListaPromocoes";
import NovaListaPromocao from "./pages/NovaListaPromocao";
import DetalheListaPromocao from "./pages/DetalheListaPromocao";
import EditarListaPromocao from "./pages/EditarListaPromocao";
import ListaOrcamentos from "./pages/ListaOrcamentos";
import DashboardV3 from "./pages/DashboardV3";
import DesempenhoAtendentes from "./pages/DesempenhoAtendentes";
import DesempenhoAtendenteHistorico from "./pages/DesempenhoAtendenteHistorico";
import Discador from "./pages/Discador";
import Ura from "./pages/Ura";
import { SoftphoneProvider } from "./contexts/softphone";
import SoftphoneWidget from "./components/SoftphoneWidget";
import SoftphoneAlerts from "./components/SoftphoneAlerts";
import ActiveCallBanner from "./components/ActiveCallBanner";
import DREConsolidado from "./pages/DREConsolidado";
import DREDetalhado from "./pages/DREDetalhado";
import DRECustos from "./pages/DRECustos";
import DRECategorias from "./pages/DRECategorias";
import DREFuroEstoque from "./pages/DREFuroEstoque";
import Clientes from "./pages/Clientes";
import CRM from "./pages/CRM";
import Mensageria from "./pages/Mensageria";
import MelhorEnvioDashboard from "./pages/MelhorEnvio";
import Lalamove from "./pages/Lalamove";
import AssistenteVendas from "./pages/AssistenteVendas";
import ChatIA from "./pages/ChatIA";
import CompatibilidadeCatalogo from "./pages/CompatibilidadeCatalogo";
import BotAtendimento from "./pages/BotAtendimento";
import BotCustosIA from "./pages/BotCustosIA";
import BotTesteAB from "./pages/BotTesteAB";
import CotacoesEmail from "./pages/CotacoesEmail";
import CompraInteligente from "./pages/CompraInteligente";
import ComprasFabrica from "./pages/ComprasFabrica";
import PrecificacaoInteligente from "./pages/PrecificacaoInteligente";
import Solicitacoes from "./pages/Solicitacoes";
import SolicitacaoPublica from "./pages/SolicitacaoPublica";
import ConsultaEstoqueFornecedor from "./pages/ConsultaEstoqueFornecedor";
import Usuarios from "./pages/Usuarios";
import LogAcessos from "./pages/LogAcessos";
import RevisaoEstoque from "./pages/RevisaoEstoque";
import TransferenciaEstoque from "./pages/TransferenciaEstoque";
import BancoImagens from "./pages/BancoImagens";
import LogsImagens from "./pages/LogsImagens";
import ImagensBloqueadas from "./pages/ImagensBloqueadas";
import MigracaoImagens from "./pages/MigracaoImagens";
import ComparadorPrecos from "./pages/ComparadorPrecos";
import EntradaEstoqueMobile from "./pages/EntradaEstoqueMobile";

import { AuthProvider, AuthContext } from "./contexts/auth";
import { AtalhosProvider } from "./contexts/atalhos";
import { ChakraProvider, CSSReset, extendTheme, useColorMode } from "@chakra-ui/react";
import AtualizacaoDisponivel from "./components/AtualizacaoDisponivel";
import { podeVerDashboard } from "./services/permission";

const theme = extendTheme({
  styles: {
    global: {},
  },
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  }
});

const sessionStorageManager = {
  get(init) {
    if (typeof window === "undefined") return init;
    return window.sessionStorage.getItem("chakra-ui-color-mode") || init;
  },
  set(value) {
    if (typeof window === "undefined") return;
    window.sessionStorage.setItem("chakra-ui-color-mode", value);
  },
  type: "cookie",
};

const Layout = ({ children }) => {
  const { authenticated } = useContext(AuthContext);
  const location = useLocation();
  const { colorMode, setColorMode } = useColorMode();

  useEffect(() => {
    if (!location.pathname.startsWith('/wiki') && colorMode === 'dark') {
      setColorMode('light');
    }
  }, [location.pathname, colorMode, setColorMode]);

  const hideNavbarRoutes = ['/login', '/wiki'];

  const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname) ||
    location.pathname.startsWith('/wiki/') ||
    location.pathname.startsWith('/responder-cotacao') ||
    location.pathname.startsWith('/solicitacao/') ||
    location.pathname.startsWith('/lista-compras/');

  if (!authenticated || shouldHideNavbar) {
    return <>{children}</>;
  }

  return (
    <>
      <NavBarTop />
      <NavBar />
      <ActiveCallBanner />
      {children}
      <SoftphoneWidget />
      <SoftphoneAlerts />
    </>
  );
};

const AppRoutes = () => {

  const HomeRedirect = () => {
    const { user } = useContext(AuthContext);

    if (user && user.tipo === 4) {
      return <Navigate to="/tickets" replace />;
    }
    return <DashboardV3 />;
  };

  const Private = ({ children, permissao, regra }) => {
    const { authenticated, loading, user } = useContext(AuthContext);
    const location = useLocation();

    if (loading) {
      return <div className="loading">Carregando...</div>;
    }

    if (!authenticated) {
      return <Navigate to="/login" />;
    }

    // Regra propria da rota substitui a checagem por permissoes
    if (regra) {
      return regra(user) ? children : <Navigate to="/not_found" />;
    }

    // Checa permissao pela rota base
    const perms = user?.permissoes || [];
    const rotaCheck = permissao || location.pathname;

    // Admin (tipo 1) passa sempre. Fora isso a permissao precisa estar na
    // lista: lista VAZIA NEGA. A escotilha antiga ("sem permissao nenhuma =
    // usuario antigo, libera tudo") virava o contrario do que promete —
    // usuario recem-criado nasce sem linha e passaria em tudo. O backend
    // (middleware PermissaoPagina) ja responde 403 nesse caso; deixar a tela
    // liberando so faria o menu inteiro aparecer e 403 em cada clique.
    if (user?.tipo !== 1) {
      const temPermissao = perms.some(p => {
        const rota = String(p || "").trim();
        // Linha em branco liberaria qualquer rota que comece com "/".
        if (!rota) return false;
        return rotaCheck === rota || rotaCheck.startsWith(rota + "/");
      });
      if (!temPermissao) {
        return <Navigate to="/not_found" />;
      }
    }

    return children;
  };

  const AdminOnly = ({ children }) => {
    const { authenticated, loading, user } = useContext(AuthContext);

    if (loading) return <div className="loading">Carregando...</div>;
    if (!authenticated) return <Navigate to="/login" />;
    if (user?.tipo !== 1) return <Navigate to="/not_found" />;

    return children;
  };

  return (
    <ChakraProvider theme={theme} colorModeManager={sessionStorageManager}>
      <AtualizacaoDisponivel />
      <Router basename="/">
        <AuthProvider>
          <SoftphoneProvider>
          <AtalhosProvider>
          <Layout>
            <Routes>
              <Route exact path="/" element={<Private permissao="/dashboard"><HomeRedirect /></Private>} />
              <Route exact path="/not_found" element={<NotFoundPage />} />
              <Route exact path="/login" element={<Login />} />
              <Route exact path="/teste" element={<Teste />} />
              <Route exact path="/dashboard" element={<Private regra={podeVerDashboard}><DashboardV3 /></Private>} />
              <Route exact path="/dre" element={<Private><DREConsolidado /></Private>} />
              <Route exact path="/dre/detalhado" element={<Private permissao="/dre"><DREDetalhado /></Private>} />
              <Route exact path="/dre/custos" element={<Private permissao="/dre"><DRECustos /></Private>} />
              <Route exact path="/dre/categorias" element={<Private permissao="/dre"><DRECategorias /></Private>} />
              <Route exact path="/dre/origens-ia" element={<Navigate to="/dre/custos" replace />} />
              <Route exact path="/dre/furo-estoque" element={<Private permissao="/dre"><DREFuroEstoque /></Private>} />
              <Route exact path="/desempenho" element={<Private><DesempenhoAtendentes /></Private>} />
              <Route exact path="/desempenho/atendentes/:id" element={<Private permissao="/desempenho"><DesempenhoAtendenteHistorico /></Private>} />
              <Route exact path="/discador" element={<Private><Discador /></Private>} />
              <Route exact path="/ura" element={<Private permissao="/ura"><Ura /></Private>} />
              <Route exact path="/comparador-precos" element={<Private permissao="/comparador-precos"><ComparadorPrecos /></Private>} />
              <Route exact path="/entrada-estoque" element={<Private permissao="/entrada-estoque"><EntradaEstoqueMobile /></Private>} />
              <Route exact path="/produtos" element={<Private><Produtos /></Private>} />
              <Route exact path="/produtos-bloqueados" element={<Private><ProdutosBloqueados /></Private>} />
              <Route exact path="/anuncios/denuncias" element={<Private><AnunciosDenuncias /></Private>} />
              <Route exact path="/perguntas" element={<Private><Perguntas /></Private>} />
              <Route exact path="/vendas" element={<Private><Vendas /></Private>} />
              <Route exact path="/vendas/card-preview" element={<Private permissao="/vendas"><VendasCardPreview /></Private>} />
              <Route exact path="/logs" element={<Private><Logs /></Private>} />
              <Route exact path="/concorrencia" element={<Private><Concorrencia /></Private>} />
              <Route exact path="/compatibilidade-catalogo" element={<Private permissao="/compatibilidade-catalogo"><CompatibilidadeCatalogo /></Private>} />
              <Route exact path="/guias" element={<Private><Guias /></Private>} />
              <Route exact path="/gestao_estoque" element={<Private><GestaoEstoque /></Private>} />
              <Route exact path="/vendas_vendedor" element={<Private><VendasVendedor /></Private>} />
              <Route exact path="/venda_manual" element={<Private><VendaManual /></Private>} />
              <Route exact path="/devolucoes" element={<Private><Devolucoes /></Private>} />
              <Route exact path="/devolucoes-fornecedor" element={<Private><DevolucaoFornecedor /></Private>} />
              <Route exact path="/nfe-devolucao-cliente" element={<Private><NfeDevolucaoCliente /></Private>} />
              <Route exact path="/reclamacoes" element={<Private><Reclamacoes /></Private>} />
              <Route exact path="/cotacoes_automaticas" element={<Private><CotacaoAutomatica /></Private>} />
              <Route exact path="/cotacoes" element={<Private><ListarCotacoes /></Private>} />
              <Route exact path="/cobertura-furos" element={<Private><CoberturaFuros /></Private>} />
              <Route exact path="/compras-fabrica" element={<Private><ComprasFabrica /></Private>} />
              <Route exact path="/responder-cotacao/:token" element={<ResponderCotacao />} />
              <Route exact path="/lista-compras/:hash" element={<ListaComprasFornecedor />} />
              <Route exact path="/solicitacao/:token" element={<SolicitacaoPublica />} />
              <Route exact path="/consulta-estoque/:hash" element={<ConsultaEstoqueFornecedor />} />
              <Route exact path="/cotacoes/:token" element={<Private permissao="/cotacoes"><DetalheCotacao /></Private>} />
              <Route exact path="/servidor" element={<Private><Servidor /></Private>} />
              <Route exact path="/acompanhamento_pedidos" element={<Private><AcompanhamentoPedidos /></Private>} />
              <Route exact path="/despacho" element={<Private><Despacho /></Private>} />
              <Route exact path="/pendencias-vendas" element={<Private><PendenciasVendas /></Private>} />
              <Route exact path="/processador/monitoramento" element={<Private><ProcessadorMonitoramento /></Private>} />
              <Route exact path="/processador/monitoramento/:data" element={<Private permissao="/processador/monitoramento"><ProcessadorMonitoramentoDia /></Private>} />
              <Route exact path="/tickets" element={<Private><Tickets /></Private>} />
              <Route path="/tickets/novo" element={<Private permissao="/tickets"><TicketCreatePage /></Private>} />
              <Route path="/tickets/:ticketId/editar" element={<Private permissao="/tickets"><TicketEditPage /></Private>} />
              <Route path="/tickets/:ticketId" element={<Private permissao="/tickets"><TicketDetailPage /></Private>} />
              <Route exact path="/prospeccao" element={<Private><Prospeccao /></Private>} />
              <Route exact path="/prospeccao/:id" element={<Private permissao="/prospeccao"><ProspeccaoDetalhes /></Private>} />
              <Route exact path="/configuracoes" element={<Private><Configuracoes /></Private>} />
              <Route exact path="/dimensoes" element={<Private><Dimensoes /></Private>} />
              <Route exact path="/logs_produtos" element={<Private><LogsProdutos /></Private>} />
              <Route exact path="/exportar_produtos" element={<Private><ExportarProdutos /></Private>} />
              <Route exact path="/exportar_clientes" element={<Private><ExportarClientes /></Private>} />
              <Route exact path="/exportar_vendas" element={<Private><ExportarVendas /></Private>} />
              <Route exact path="/exportar_conversas" element={<Private><ExportarConversas /></Private>} />
              <Route exact path="/exportar_listas_compras" element={<Private><ExportarListasCompras /></Private>} />
              <Route exact path="/exportar_movimentacao_estoque" element={<AdminOnly><ExportarMovimentacaoEstoque /></AdminOnly>} />
              <Route exact path="/exportar_xml_nfe" element={<AdminOnly><Navigate to="/notas_fiscais?aba=exportar" replace /></AdminOnly>} />
              <Route exact path="/listas-compras/dashboard" element={<Private><ListasComprasDashboard /></Private>} />
              <Route exact path="/listas-compras" element={<Private permissao="/listas-compras/dashboard"><ListasCompras /></Private>} />
              <Route exact path="/listas-compras/nova" element={<Private permissao="/listas-compras/dashboard"><NovaListaCompra /></Private>} />
              <Route exact path="/listas-compras/kanban" element={<Private permissao="/listas-compras/dashboard"><ListasComprasKanban /></Private>} />
              <Route exact path="/listas-compras/:id" element={<Private permissao="/listas-compras/dashboard"><ListaCompraDetalhes /></Private>} />
              <Route exact path="/notas_fiscais" element={<Private><NotasFiscais /></Private>} />
              <Route exact path="/wiki" element={<Private><SupportWiki /></Private>} />
              {/* Link direto para uma página da wiki (compartilhamento interno) */}
              <Route exact path="/wiki/:id" element={<Private permissao="/wiki"><SupportWiki /></Private>} />

              <Route exact path="/promocoes" element={<Private><ListaPromocoes /></Private>} />
              <Route exact path="/promocoes/nova" element={<Private permissao="/promocoes"><NovaListaPromocao /></Private>} />
              <Route exact path="/promocoes/:id" element={<Private permissao="/promocoes"><DetalheListaPromocao /></Private>} />
              <Route exact path="/promocoes/:id/editar" element={<Private permissao="/promocoes"><EditarListaPromocao /></Private>} />
              <Route exact path="/orcamentos" element={<Private><ListaOrcamentos /></Private>} />

              <Route exact path="/dash1" element={<Private permissao="/dashboard"><Dashboard /></Private>} />

              <Route exact path="/clientes" element={<Private><Clientes /></Private>} />
              <Route exact path="/crm" element={<Private permissao="/crm"><CRM /></Private>} />
              <Route exact path="/mensageria" element={<Private permissao="/mensageria"><Mensageria /></Private>} />
              <Route exact path="/melhor-envio" element={<Private><MelhorEnvioDashboard /></Private>} />
              <Route exact path="/lalamove" element={<Private permissao="/lalamove"><Lalamove /></Private>} />
              <Route exact path="/assistente-vendas" element={<Private><AssistenteVendas /></Private>} />
              <Route exact path="/chat-ia" element={<Private><ChatIA /></Private>} />
              <Route exact path="/bot-atendimento" element={<Private permissao="/assistente-vendas"><BotAtendimento /></Private>} />
              <Route exact path="/bot-custos-ia" element={<AdminOnly><BotCustosIA /></AdminOnly>} />
              <Route exact path="/bot-teste-ab" element={<AdminOnly><BotTesteAB /></AdminOnly>} />
              <Route exact path="/cotacoes-email" element={<Private><CotacoesEmail /></Private>} />
              <Route exact path="/compra-inteligente" element={<AdminOnly><CompraInteligente /></AdminOnly>} />
              <Route exact path="/divergencias-preco" element={<AdminOnly><DivergenciasPreco /></AdminOnly>} />
              <Route exact path="/publicidade-ml" element={<AdminOnly><PublicidadeML /></AdminOnly>} />
              <Route exact path="/saude-anuncios" element={<AdminOnly><SaudeAnunciosML /></AdminOnly>} />
              <Route exact path="/metricas-anuncios" element={<AdminOnly><MetricasAnuncios /></AdminOnly>} />
              <Route exact path="/precificacao-inteligente" element={<AdminOnly><PrecificacaoInteligente /></AdminOnly>} />
              <Route exact path="/solicitacoes" element={<Private permissao="/assistente-vendas"><Solicitacoes /></Private>} />

              <Route exact path="/usuarios" element={<Private><Usuarios /></Private>} />
              <Route exact path="/log-acessos" element={<Private><LogAcessos /></Private>} />
              <Route exact path="/revisao-estoque" element={<Private><RevisaoEstoque /></Private>} />
              <Route exact path="/transferencia-estoque" element={<Private><TransferenciaEstoque /></Private>} />
              <Route exact path="/banco-imagens" element={<Private><BancoImagens /></Private>} />
              <Route exact path="/logs-imagens" element={<Private permissao="/banco-imagens"><LogsImagens /></Private>} />
              <Route exact path="/imagens-bloqueadas" element={<Private><ImagensBloqueadas /></Private>} />
              <Route exact path="/migracao-imagens" element={<AdminOnly><MigracaoImagens /></AdminOnly>} />

            </Routes>
          </Layout>
          </AtalhosProvider>
          </SoftphoneProvider>
        </AuthProvider>
      </Router>
    </ChakraProvider>
  );
};

export default AppRoutes;